import Model from '@/models/Model'

export default class PosCustomerReceivablePayment extends Model {
    static includes = ['pos_detail_customer_receivable_payments']
    static appends = ['transformed_payments']

    resource() {
        return 'pos_customer_receivable_payment'
    }

    get realPayDate() {
        try {
            if (this.pos_detail_customer_receivable_payments)
                return this.pos_detail_customer_receivable_payments[0]
                    .created_at
        } catch (e) {
            return `e: ${e}`
        }
    }

    get paidAmount() {
        try {
            if (this.pos_detail_customer_receivable_payments)
                return this.pos_detail_customer_receivable_payments[0].amount
        } catch (e) {
            return `e: ${e}`
        }
    }

    get paymentMathod() {
        try {
            if (this.transformed_payments)
                return this.transformed_payments[0].type
        } catch (e) {
            return `e: ${e}`
        }
    }
}
